import React, { FC, useEffect } from 'react'
import styles from 'styles/components/header.module.scss'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { getIsAdmin, getSwitchingStoreRefs } from 'reducks/auth/selectors'
import { SwitchingStoreRefType } from 'types/auth'
import { AdminSwitchCard, StoreSwitchCard } from 'components/Card'

type Props = {
  subHeaderInnerHeight: number
}

const SubHeaderNavMenu: FC<Props> = (props) => {
  const { subHeaderInnerHeight } = props
  const ref = React.createRef<HTMLDivElement>()
  const isAdmin = useSelector((state: State) => getIsAdmin(state))
  const switchingStoreRefs: SwitchingStoreRefType[] = useSelector((state: State) => getSwitchingStoreRefs(state))
  // 要素の高さが変わったらoverflow-y: scrollを有効化するために高さを明示的に指定する
  useEffect(() => {
    setTimeout(() => {
      const elm = ref.current
      if (!elm) return
      const clientHeight = elm.clientHeight
      const innerHeight = window.innerHeight
      const headerHeight = 52
      const subHeaderHeight = subHeaderInnerHeight
      const paddingHeight = 32
      const maxNavHeight = innerHeight - (headerHeight + subHeaderHeight + paddingHeight)
      // 要素の高さがSubHeaderNavMenuの最大高さより低ければそのまま
      if (clientHeight < maxNavHeight) return
      // SubHeaderNavMenuの最大高さを指定
      elm.style.height = `${maxNavHeight + paddingHeight}px`
    }, 500)
  }, [ref, subHeaderInnerHeight])

  return (
    <div className={styles.subheader__nav}>
      <div className={styles.subheader__nav__inner} ref={ref}>
        {isAdmin && <AdminSwitchCard />}
        {switchingStoreRefs.map((switchingStoreRef) => (
          <StoreSwitchCard
            key={
              switchingStoreRef.store_ref.id +
              (switchingStoreRef.manufacturer_ref ? switchingStoreRef.manufacturer_ref.id : '')
            }
            switchingStoreRef={switchingStoreRef}
          />
        ))}
      </div>
    </div>
  )
}

export default SubHeaderNavMenu
